module.exports = __webpack_public_path__ + "img/clam_pack.15ae8fab.png";